const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/technologies/$id.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { dehydrate } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { zodSearchValidator } from "@tanstack/router-zod-adapter";
import { formatTechnologyKey } from "@/components/technology/TechnologyProfileHeader";
import i18n from "@/lib/i18n";
import { technologyProfileQueryOptions } from "@/queries/technology-profile";
import { formSchema } from "@/stores/searchStore";
export const Route = createFileRoute("/{-$locale}/technologies/$id")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodSearchValidator(formSchema),
  loader: async ({
    context,
    params
  }) => {
    const technology = await context.queryClient.fetchQuery(technologyProfileQueryOptions(params.id)).catch(() => null);
    return {
      id: params.id,
      technology,
      dehydratedState: dehydrate(context.queryClient)
    };
  },
  head: ({
    params,
    loaderData
  }) => {
    const fallbackName = formatTechnologyKey(params.id);
    const name = loaderData?.technology?.status === "ready" ? loaderData.technology.profile.displayName : fallbackName;
    const description = loaderData?.technology?.status === "ready" ? loaderData.technology.profile.summary : i18n.t("technologies.meta.description", {
      name
    });
    const title = i18n.t("technologies.meta.title", {
      name
    });
    const logoUrl = loaderData?.technology?.status === "ready" ? loaderData.technology.logo?.url : null;
    const logoAlt = i18n.t("technologies.logoAlt", {
      name
    });
    return {
      meta: [{
        title
      }, {
        name: "description",
        content: description
      }, {
        property: "og:title",
        content: title
      }, {
        property: "og:description",
        content: description
      }, {
        name: "twitter:title",
        content: title
      }, {
        name: "twitter:description",
        content: description
      }, ...(logoUrl ? [{
        property: "og:image",
        content: logoUrl
      }, {
        property: "og:image:alt",
        content: logoAlt
      }, {
        name: "twitter:card",
        content: "summary"
      }, {
        name: "twitter:image",
        content: logoUrl
      }, {
        name: "twitter:image:alt",
        content: logoAlt
      }] : [])]
    };
  }
});